export const Grafbase = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M10.627 1.393a.711.711 0 0 1-.318.953l-7.02 3.51L10 9.211l6.71-3.354-2.564-1.28-3.833 1.915a.71.71 0 1 1-.635-1.272l4.15-2.073a.71.71 0 0 1 .635 0l4.154 2.073a.71.71 0 0 1 0 1.272l-8.29 4.145a.71.71 0 0 1-.326.075.708.708 0 0 1-.328-.075l-8.29-4.145a.71.71 0 0 1 0-1.272l8.29-4.145a.71.71 0 0 1 .954.318ZM1.076 13.826a.71.71 0 0 1 .953-.318l7.973 3.987 7.973-3.987a.71.71 0 1 1 .636 1.272l-8.29 4.145a.711.711 0 0 1-.636 0L1.394 14.78a.712.712 0 0 1-.318-.954Z"
        clipRule="evenodd"
      />
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M1.076 9.68a.71.71 0 0 1 .953-.317l7.973 3.986 7.973-3.986a.71.71 0 0 1 .636 1.27l-8.29 4.146a.711.711 0 0 1-.636 0l-8.291-4.145a.71.71 0 0 1-.318-.954Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
